import React, { useState, useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import "./css/KitchenReg.css";
import 'bootstrap/dist/css/bootstrap.css';
import SideNav from './SideNav'
import TopRootDiv from './TopRootDiv';
import SherDineNav from './SherDineNav';
import { ToastContainer, toast } from 'react-toastify';
import edit from './images/MenuReg/Editing1.png'
import tick from './images/icons/check.png'
import cross from './images/icons/cross.png'
import { DBContext } from './DBContext'
import axios from 'axios'

function KitchenReg() {

    const [collapsed, setCollapsed] = useState(false);
    const [KitchenName, setKitchenName] = useState("");
    const [KitchenCode, setKitchenCode] = useState("");
    const [Database, setDatabase] = useState(localStorage.getItem('DB'));
    const [imgCode, setImgCode] = useState(localStorage.getItem('imgCode'));
    const [company, setCompany] = useState(localStorage.getItem('Company'));
    const location = useLocation(null)

    const [item, setItem] = useState({})

    const [kitchenId,setKitchenId] = useState(null)
    const [kitchen,setKitchen] = useState(null)

    useEffect(() => {
        if (location.state) {
            setKitchenId(location.state.id)
            setKitchen(location.state.kitchen)
        }
    },[location])

    const toggleSidebar = () => {
        setCollapsed(!collapsed);
    };
    const api_base_url = process.env.REACT_APP_API_BASE_URL

    const { logginedDB , user_Id } = useContext(DBContext);

    const [kitchenCodeOldToUpdate,setKitchenCodeOldToUpdate] = useState(null)
    
    const handleSubmit = async () => {

        if (!KitchenName || !KitchenCode || avail === 0 || availCode === 0 || avail === null || !codeDisable && (availCode === null)) {
            alert("Please fill in all fields.");
            return;
        }

        const data = {
            KitchenName: KitchenName,
            KitchenCode: KitchenCode
        };

        const currentDate = new Date().toISOString().split('T')[0];

        const formatTime = () => {
            let now = new Date();
            let hours = now.getHours();
            let minutes = now.getMinutes();
            const ampm = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12; // Convert 24-hour to 12-hour format
            minutes = minutes.toString().padStart(2, '0'); // Ensure two-digit minutes
            return `${hours}:${minutes} ${ampm}`;
        };

        const eventDetails = {
            ddate: currentDate,
            ttime: formatTime(),
            user_Id: user_Id, // Replace with actual user ID variable
            // user: userName // Replace with actual user variable
        };

        let response;

        try {
            //("Try");
            if (kitchenId) {
                response = await fetch(`${api_base_url}/KitchenRegUpdate/${kitchenId}/${kitchenCodeOldToUpdate}/${logginedDB}/${JSON.stringify(eventDetails)}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                });
            } else {
                response = await fetch(`${api_base_url}/KitchenReg/${logginedDB}/${JSON.stringify(eventDetails)}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify(data)
                });
            }

            if (response.ok) {
                toast.success("Kitchen successully Registered",{
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => {}
                });
                // Optionally, reset the form fields here
                setKitchenName("");
                setKitchenCode("");
                navigate('/basemenureg', {
                    state: 'KitchenCancel'
                })
                
            } else {
                toast.error("Kitchen Registered Failed. Please try again.",{
                    className: 'custom-toast',
                    bodyClassName: 'custom-toast-container',
                    closeButtonClassName: 'custom-toast-close-button',
                    onClose: () => {}
                });
                console.error("Failed to submit data");
            }

        } catch (error) {
            toast.error("Kitchen Registered Failed. Please try again.",{
                className: 'custom-toast',
                bodyClassName: 'custom-toast-container',
                closeButtonClassName: 'custom-toast-close-button',
                onClose: () => {}
            });
            console.error("Error:", error);
        }
        
    }
    
    const [avail,setAvail] = useState(null)
    const [availCode,setAvailCode] = useState(null)
    const [autoKitchenCode,setAutoKitchenCode] = useState(null)
    const [codeDisable,setCodeDisable] = useState(true)

    function getInitialsUppercase(str) {
        if (!str) return ""; // Handle empty or null strings
        return str
            .split(' ')               // Split the string into words
            .map(word => word[0]?.toUpperCase() || '') // Get the first letter of each word in uppercase
            .join('');                // Join the initials into a single string
    }

    const handleAutoKitchenCode = async (val) => {
        const code = getInitialsUppercase(val)
        try {
            const response = await axios.get(`${api_base_url}/autoKitchenCode/${code}/${logginedDB}`)
            if (response.status === 200) {
                const codeAvail = response.data.nextAvailableCode
                setAutoKitchenCode(codeAvail)
                setKitchenCode(codeAvail)
            }
        } catch (error) {
            //(error);
        }
    }

    const handleCheckAvailableCode = async (val) => {
        if (val === '') return setAvailCode(null)
        try {
            const response = await axios.get(`${api_base_url}/checkAvailablityKitchenCode/${val}/${logginedDB}`)
            if (response.status === 200) {
                const checked = response.data.isAvailable
                
                if (checked == 0) {
                    setAvailCode(1)
                } else {
                    setAvailCode(0)
                }
            }
        } catch (error) {
            //(error);
        }
    }
    
    const handleCheckAvailableName = async (val) => {
        if (val === '') return setAvail(null)
        try {
            const response = await axios.get(`${api_base_url}/checkAvailablityKitchen/${val}/${logginedDB}`)
            if (response.status === 200) {
                const checked = response.data.isAvailable
                if (checked == 0) {
                    setAvail(1)
                    handleAutoKitchenCode(val)
                } else {
                    setAvail(0)
                    setAutoKitchenCode(null)
                }
            }
        } catch (error) {
            //(error);
        }
    }

    const handleModifyAreaCode = async () => {

        const userConfirmed = window.confirm(`Custom kitchen code ?`);

        if (!userConfirmed) {
            return;
        }
        handleCheckAvailableCode(availCode)
        setCodeDisable(false)
    }
    
    const handleKitchenNameChange = (event) => {
        const val = event.target.value
        setCodeDisable(true)
        setKitchenName(val);
        handleCheckAvailableName(val)
    };

    const handleKitchenCodeChange = (event) => {
        const val = event.target.value
        setKitchenCode(val);
        handleCheckAvailableCode(val)
    };

    const handleKitchenPrinterChange = (event) => {
        // const val = event.target.value
        // setKitchenCode(val);
        // handleCheckAvailableCode(val)
    };

    const handleModifyKitchen = async () => {
        try {
            const response = await axios.get(`${api_base_url}/getKitchenDetails/${kitchenId}/${logginedDB}`)
            if (response.status == 200) {
                setKitchenName(response.data[0].KitchenName)
                setKitchenCode(response.data[0].KitchenCode)
                setKitchenCodeOldToUpdate(response.data[0].KitchenCode)
            }
        } catch (error) {
            //(error);
        }
    }

    useEffect(() => {
        if (kitchenId) {
            handleModifyKitchen()
        }
    },[kitchenId])
    
    useEffect(() => {
        const handleWindowResize = () => {
            if (window.innerWidth <= 768) {
                setCollapsed(true);
            } else {
                setCollapsed(false);
            }
        };

        window.addEventListener("resize", handleWindowResize);

        return () => {
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);


    const navigate = useNavigate();

    const handleCancel = () => {
        navigate('/basemenureg', {
            state: 'KitchenCancel'
        })
    }

    const handleSaveArea = () => {

    }

    const [sideNav, setSideNav] = useState(false)
    const handleSideNav = (state) => {
        setSideNav(state)
    }
    const [falseState, setFalseState] = useState(null)

    return (
        <div className='KitchenRegMainDiv'>
            <SherDineNav sideNav={(state) => handleSideNav(state)} falseState={falseState} />
            <div className='KitchenRegContentDiv flex gap-3'>
                <SideNav focus={'Menu'} state={sideNav} falseState={(state) => setFalseState(state)} />
                <div className='KitchenRegContentSideBarRight'>
                    <div className="KitchenRegSidebar">
                        <TopRootDiv image={'Menu Management'} root={['Menu Management', 'Base Menu']} section={'Add Kitchen'} />
                    </div>
                    <div className='Container_Menu KitchenRegForm flex flex-col h-full pt-3'>
                        <div className='TableAreaReg_areaDetails_span bg-white rounded-t-md border-b'>
                            <span>{kitchen ? kitchen : 'Kitchen Details'}</span>
                            <div className=' AddItem_Buttons AddItem_Buttons_TableAreaReg text-nowrap'>
                                <button className='loginBorder text-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3' onClick={handleCancel}>Cancel</button>
                                <button className='loginBorder text-[#fff] bg-[#0008B4] rounded-[.313rem] pt-1 pb-1 pl-3 pr-3' onClick={handleSubmit}>Save</button>
                            </div>
                        </div>
                        {/* <div className='KitchenRegForm_Contents '> */}
                        <div className='w-full flex flex-col gap-4 p-4 bg-white flex-grow h-full rounded-b-md shadow-sm border border-t-0 border-gray-200'>
                            <div className='w-full flex gap-3'>
                                <div className='KitchenRegForm_part_spanInput'>
                                    <span>Kitchen Name</span>
                                    {/* <input className="KitchenName p-2" type="text" value={KitchenName} onChange={handleKitchenNameChange} /> */}
                                    <div className='w-full flex areaBorder h-[2.5rem] rounded-[.313rem]'>
                                        <input className='w-full h-auto border-0 p-2' type="text" 
                                        value={KitchenName}
                                        onChange={handleKitchenNameChange}/>
                                        <div className='w-max flex justify-center items-center p-2'>
                                            { avail == 1 && <img className='w-[1.25rem]' src={tick} alt="" /> }
                                            { avail == 0 && <img className='w-[1.25rem]' src={cross} alt="" /> }
                                        </div>
                                    </div>
                                </div>
                                <div className='KitchenRegForm_part_spanInput'>
                                    <span>Kitchen Code</span>
                                    {/* <input className="KitchenCode p-2" type="text" value={KitchenCode} onChange={handleKitchenCodeChange} 
                                    disabled={codeDisable}/> */}
                                    <div className={`w-full flex h-[2.5rem] areaBorder rounded-[.313rem] ${codeDisable ? 'bg-slate-100' : ''}`}>
                                        <input className='w-full h-auto border-0 KitchenCode p-2' type="text" 
                                        value={(KitchenName !== '' && avail == 1 && codeDisable) ? autoKitchenCode : !codeDisable ? KitchenCode : kitchenId ? KitchenCode : ''}
                                        disabled={codeDisable}
                                        onChange={handleKitchenCodeChange}/>
                                        {
                                            (KitchenName !== '' && autoKitchenCode && avail == 1 && codeDisable) && (
                                                <div className='w-max flex justify-center items-center p-2'>
                                                    <img className='w-[1.25rem] cursor-pointer' src={edit} alt="" onClick={handleModifyAreaCode}/>
                                                </div>
                                            )
                                        }
                                        {
                                            !codeDisable && (
                                                <div className='w-max flex justify-center items-center p-2'>
                                                    { availCode == 1 && <img className='w-[1.25rem]' src={tick} alt="" /> }
                                                    { availCode == 0 && <img className='w-[1.25rem]' src={cross} alt="" /> }
                                                </div>
                                            )
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className='w-full flex gap-3'>
                                <div className='KitchenRegForm_part_spanInput'>
                                    <span>Kitchen Printer</span>
                                    {/* <input className="KitchenName p-2" type="text" value={KitchenName} onChange={handleKitchenNameChange} /> */}
                                    <div className='w-full flex areaBorder h-[2.5rem] rounded-[.313rem]'>
                                        <input className='w-full h-auto border-0 p-2' type="text" 
                                        value={KitchenName}
                                        onChange={handleKitchenPrinterChange}/>
                                        <div className='w-max flex justify-center items-center p-2'>
                                            { avail == 1 && <img className='w-[1.25rem]' src={tick} alt="" /> }
                                            { avail == 0 && <img className='w-[1.25rem]' src={cross} alt="" /> }
                                        </div>
                                    </div>
                                </div>
                                <div className='KitchenRegForm_part_spanInput'>
                                </div>
                            </div>
                        </div>

                        {/* </div> */}
                        {/* <div className='KitchenAreaReg_areaDetails_buttons'>
                            <button className='btn_cancel' onClick={handleCancel}>Cancel</button>
                            <button className='btn_Save'>Save</button>
                        </div> */}
                    </div>

                </div>
            </div>
        </div>
    )
}

export default KitchenReg
